import React, { useState } from 'react';
import './PriceCardBnb.css'; // Import the CSS file
import ContactUs from './ContactUs';


const PriceCardBnb = () => {

  const [showPopupOnClick, setShowPopupOnClick] = useState(false);


   const popupStyleButton = {
    position: 'fixed',
    top: '35%',
    left: '50%',
    height:'60%',
    transform: showPopupOnClick ? 'translate(-50%, -50%)' : 'translate(-50%, -150%)',
    backgroundColor: 'black',
    display: showPopupOnClick ? 'block' : 'none',
    zIndex: 9999,
    borderRadius: '15px', // Adds a border radius
   
  };

  const handleClose = () => {
    setShowPopupOnClick(false);
  };
  return (


    <>

    <div className="popup" style={popupStyleButton}>

                  <button className="close-button" onClick={handleClose}>
                      X
                    </button>
                    <ContactUs/>
                  </div>
      <div className="price-card-promo">
              <h3 className="heading-prop">Spring Exclusive Deal!</h3>
              <p className="body-text-prop">
                Your peak booking season is coming, now is the best time to get your vacation home listed, let take on the operational <br/>
                headache and stress of managing your airbnb.
              </p>
              <p className="body-text-prop">
                For a limited time we are offering <strong>3 months free basic consumables</strong> and <strong>linen hire</strong>, for all new clients.
              </p>
              <p className="body-text-prop">
                Unlock your property’s full potential with <strong>Sprucely Clean management feee starting from 6%</strong>.
              </p>
              
        </div>

    <div className="price-card-container-bnb">
      
      <div className="price-card-bnb">
        <div className="price-card-heading-box">
          <h2 className="price-card-heading-bnb">
            Clean & Turn
        </h2>
        <h8 className="plan-head">
           For cleaning only
        </h8>

        </div>
      
        <ul className="price-card-list-bnb">
        
          <li>✔ 5 star turn over-clean</li>
          <li>✔ Custom cleaning checklist</li>
          <li>✔ Restaging for next guest</li>
          <li>✔ Reset consumables (Not supplied)</li>
          <li>✔ Linen washed (Not supplied)</li>

          <li className='li-bnb-bot'> Perfect for a sole property owner looking for a budget 
          friendly turn over clean.</li>
         
        </ul>
       
        <button className="call-button-bnb-card" onClick={() => setShowPopupOnClick(true)} >More info</button>
      </div>

        <div className="price-card-bnb">
                <div className="price-card-heading-box">
                <h2 className="price-card-heading-bnb">
                     360 Management
                </h2>
                <h8 className="plan-head">
            Full 360 management service from cleaning <br/>linen, maintenance and listing marketing.
        </h8>

                </div>
                <ul className="price-card-list-bnb">
                <li>✔ Everything in the Basic plan</li>
                <li>✔ Weekly quality inspections</li>
                <li>✔ 24/7 support</li>
                <li>✔ We supply linen, so you dont have to stress about replacement</li>
                <li>✔ We supply and restock basic consumables</li>

              

                <li className='li-bnb-bot'> Top choice for multi property owners, property management companies or anyone looking for a less hands on
                management.</li>
                
                </ul>
               <button className="call-button-bnb-card" onClick={() => setShowPopupOnClick(true)} >More info</button>
      </div>


      <div className="price-card-bnb">
        <div className="price-card-heading-box">
          <h2 className="price-card-heading-bnb">
            Fractional management
        </h2>
        <h8 className="plan-head">
            For listing Optimization and marketing
        </h8>

        </div>
      
        <ul className="price-card-list-bnb">
        
          <li>✔ Guest management & communication</li>
          <li>✔ Listing Optimization</li>
          <li>✔ Listing SEO</li>
          <li>✔ Property photography & listing</li>
         

          <li className='li-bnb-bot'> Perfect choice if you just want to focus on increasing your occupancy rate.</li>
         
        </ul>
       <button className="call-button-bnb-card" onClick={() => setShowPopupOnClick(true)} >More info</button>
        
      </div>
      



    </div>

    </>


  );
};

export default PriceCardBnb;

